import { AfterViewInit, Component, ElementRef, input, model, OnInit, output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonSpinner, IonIcon } from "@ionic/angular/standalone";
import { addIcons } from 'ionicons';
import { search, arrowBack, closeCircle } from 'ionicons/icons';
import { debounceTime, distinctUntilChanged, filter, fromEvent, map, tap } from 'rxjs';

@Component({
    selector: 'app-search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
    imports: [IonSpinner, IonIcon, FormsModule]
})
export class SearchInputComponent implements OnInit, AfterViewInit {

  @ViewChild('search', { static: true }) search!: ElementRef;

  public back = model<boolean>(false);
  public loading = input<boolean>(false);
  public searchText = model<string>('');
  public debounce = input<number>(1000);
  public inputLengthThreshold = input<number>(2);

  public backEvent = output<boolean>();
  public focused = output<boolean>();
  public focusedout = output<boolean>();
  public searchClear = output<boolean>();
  public searchChanged = output<string>();

  constructor() {
    addIcons({ closeCircle, arrowBack, search });
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    fromEvent(this.search.nativeElement, 'keyup')
    .pipe(map((event: any) => event.target.value),
      filter((res: any) => res.length > this.inputLengthThreshold()),
      debounceTime(this.debounce()),
      distinctUntilChanged(),
      tap((event: KeyboardEvent) => {
        this.searchChanged.emit(this.searchText());
      })
    ).subscribe();
  }

  backAction() {
    this.searchText.set('');
    this.backEvent.emit(true);
  }

  inputFocus() {
    this.focused.emit(true);
  }

  inputFocusOut() {
    this.focusedout.emit(true);
  }

  clearSearch() {
    this.searchText.set('');
    this.searchClear.emit(true)
    this.back.set(false);
  }

}
